import {ContinuousColorLegend} from 'react-vis'
import {AxiosHttpClientAdapter} from '../../../infra/adapters/axios-adapter'
import {HttpClient} from '../../../infra/adapters/type'

export type ApiResult = {
  itens: any[]
  service: string
  total: number
  message?: string
}
export class ApiGoogleClass {
  host: string = (process.env.REACT_APP_URBIT_API_URL || '').replace(/\/?$/, '/')
  bearer: string = ''
  clienteConect: any
  constructor(httpClientRequest: HttpClient) {
    this.clienteConect = httpClientRequest
  }
  init() {
    //api
    // this.setHost()
    return []
    // setHor
  }
  setBearer(bearer) {
    this.bearer = bearer
  }
  setHost() {
  }

  getBearer() {
    return this.bearer || localStorage.getItem('api_token_api_gis') || localStorage.getItem('token') || ''
  }

  async request(method: string, url: string, data = '', types = '') {
    let body = data ? JSON.stringify(data) : null
    const result = await this.clienteConect.request({
      url: url,
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': `${process.env.REACT_APP_GOOGLE_MAPS_API}`,
        'X-Goog-FieldMask': `${types}`,

        // 'places.id',
      },
      body,
    })
    console.log('result')
    console.log(result)
    if (result.statusCode === 200) {
      return result.body
    } else {
      return {service: 'error', message: `Erro status: ${result.status}`, itens: [], total: 0}
    }
  }

  async get(url: string, callback?: any) {
    if (typeof callback == 'function') {
      fetch(this.host + url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.getBearer()}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else {
            return null
          }
        })
        .then((data) => {
          if (!data || typeof data === 'undefined') {
            callback({service: 'erro', message: data, itens: [], total: 0})
          } else {
            callback(data)
          }
        })
        .catch((err) => {
          callback({service: 'error', message: err.message, itens: [], total: 0})
        })
    } else {
      try {
        return this.request('GET', url)
      } catch (error) {
        console.error('Error:', error)
        return {service: 'error', message: error, itens: [], total: 0}
      }
    }
  }

  async post(url: string, dataInput: any, types?: string) {
    // if (typeof callback == 'function') {
    //   fetch(this.host + url, {
    //     method: 'POST', // *GET, POST, PUT, DELETE, etc.
    //     headers: {
    //       'Content-Type': 'application/json; charset=UTF-8',
    //       Authorization: `Bearer ${this.bearer}`,
    //       // 'Content-Type': 'application/x-www-form-urlencoded',
    //     },
    //     body: dataInput,
    //   })
    //     .then((response) => {
    //       if (response.status === 200) {
    //         return response.json()
    //       } else {
    //         return null
    //       }
    //     })
    //     .then((data) => {
    //       if (!data || typeof data === 'undefined') {
    //         callback({service: 'erro', message: data, itens: [], total: 0})
    //       } else {
    //         callback(data)
    //       }
    //     })
    //     .catch((err) => {
    //       callback({service: 'error', message: err.message, itens: [], total: 0})
    //     })
    // } else {
    return this.request('POST', url, dataInput, types)
    //   let data = null
    //   try {
    //     const response = await fetch(this.host + url, {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${this.bearer}`,
    //       },
    //       body: JSON.stringify(dataInput),
    //     })
    //     data = await response.json()
    //   } catch (error) {
    //     data = {service: 'error', message: error, itens: [], total: 0}
    //     console.error('Error:', error)
    //   }

    //   return data
    // }
  }
}

export const ApiGoogle = new ApiGoogleClass(new AxiosHttpClientAdapter())
